import React, { useContext } from "react";
import cx from "classnames";
import styled from "styled-components";
import Link from "next/link";

import { LINKS } from "globalConfig";
import { makeKidsUrl } from "utils";

import { AccountContext } from "contexts/AccountProvider";
import LiteratiLogo from "@/atoms/Icon/literati";
import LiteratiLogoDark from "@/atoms/Icon/literati-dark";
import { NavBarLinkNextDark } from "components/Layout/Navbar/navbarStyles";
import { MyAccountDropDown } from "components/Layout/Navbar/MyAccountDropDown";

const StyledHeader = styled.header`
  height: 4rem;
  display: flex;
  align-items: center;

  .navbar-logo {
    img {
      width: auto;
      height: 22px;
    }
  }
`;

const Header = ({ displayMenu, theme, className }) => {
  const { isAuthenticated } = useContext(AccountContext);
  const themeClasses = {
    dark: "bg-ink-black text-page-white",
    light: "bg-white text-ink-black",
  }[theme];

  return (
    <StyledHeader className={cx(themeClasses, className)}>
      <div
        className={"content-spacing flex justify-between items-center w-full"}
      >
        <Link href="/">
          <a className="navbar-logo">
            {theme === "dark" ? <LiteratiLogo /> : <LiteratiLogoDark />}
          </a>
        </Link>
        {isAuthenticated ? (
          <MyAccountDropDown />
        ) : (
          <NavBarLinkNextDark
            data-analytics="nav-sign-in-cta"
            href={makeKidsUrl(LINKS.login)}
            variant="button"
            legacyBehavior={undefined}
          >
            Log In
          </NavBarLinkNextDark>
        )}
      </div>
    </StyledHeader>
  );
};

Header.defaultProps = {
  theme: "dark",
};

export default Header;
